import { render } from "./QuestFilter.vue?vue&type=template&id=966a663a&scoped=true"
import script from "./QuestFilter.vue?vue&type=script&lang=js"
export * from "./QuestFilter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-966a663a"]])

export default __exports__